module.exports = __webpack_public_path__ + "static/media/ts1tj64.bc25c1e2.png";